import { BaseModel } from '../../_base/crud';

export class Role extends BaseModel {
    role_id: number;
    role_name_ar: string;
    role_name_en: string;
	role_name: string;
	permissions: []

    clear(): void {
        this.role_id = undefined;
        this.role_name_ar = '';
        this.role_name_en = '';
        this.role_name = '';
        this.permissions = [];
	}
}
